// src/AirplaneMultipleTrips.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var AirplaneMultipleTrips_default = createIcon({
  displayName: "AirplaneMultipleTrips",
  viewBox: "0 0 25 23",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        opacity: "0",
        width: "25",
        height: "23",
        fill: "white",
        fillOpacity: "0"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M13.999 4.58313C13.2627 4.58313 12.6657 5.18007 12.6657 5.91643V9.50227L7.65933 12.6285C7.45601 12.7558 7.33252 12.9783 7.33252 13.2183C7.33252 13.6883 7.78749 14.0237 8.23614 13.8837L12.6657 12.5035V16.0763L11.5577 16.9044C11.4157 17.0104 11.3324 17.1776 11.3324 17.3549C11.3324 17.7203 11.6763 17.9879 12.0303 17.8992L13.999 17.407L15.9677 17.8992C16.3217 17.9879 16.6656 17.7203 16.6656 17.3549C16.6656 17.1776 16.5824 17.0104 16.4404 16.9044L15.3323 16.0763V12.5035L19.7619 13.8837C20.2105 14.0237 20.6655 13.6883 20.6655 13.2183C20.6655 12.9783 20.542 12.7558 20.3387 12.6285L15.3323 9.50227V5.91643C15.3323 5.18007 14.7354 4.58313 13.999 4.58313Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M13.9991 0.5C13.4468 0.5 12.9991 0.947704 12.9991 1.49997C12.9991 2.05224 13.4468 2.49995 13.9991 2.49995C18.9695 2.49995 22.9988 6.52928 22.9988 11.4997C22.9988 16.4701 18.9695 20.4995 13.9991 20.4995C9.02862 20.4995 4.99929 16.4701 4.99929 11.4997C4.99929 10.4149 5.19079 9.37646 5.5415 8.41514L5.93194 9.87229C6.07488 10.4057 6.6232 10.7223 7.15665 10.5794C7.6901 10.4364 8.00668 9.88812 7.86374 9.35467L6.56968 4.52516L1.74018 5.81923C1.20672 5.96216 0.890149 6.51049 1.03309 7.04394C1.17603 7.57739 1.72435 7.89397 2.2578 7.75103L3.81601 7.33351C3.28941 8.61942 2.99934 10.0267 2.99934 11.4997C2.99934 17.5747 7.92408 22.4994 13.9991 22.4994C20.074 22.4994 24.9988 17.5747 24.9988 11.4997C24.9988 5.42474 20.074 0.5 13.9991 0.5Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      })
    ]
  })
});

export {
  AirplaneMultipleTrips_default
};
